var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('BannerSection'),_c('Services'),_c('WhoWeAre'),_c('Portfolio',{attrs:{"title":"Featured Projects","path":_vm.path}}),_c('CompanyStats'),_c('Testimonials')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }